import { DataGrid as DG, enUS, zhTW } from "@mui/x-data-grid";
import React from "react";
import { twMerge } from "tailwind-merge";

import GridPagination from "./GridPagination";
import { XDataGridProps } from "./XDataGridProps";

const XDataGrid = ({
  rowHeight = 48,
  emptyView,
  lang = "zh",
  ...props
}: XDataGridProps) => {
  const l = lang === "zh" ? zhTW : enUS;
  const labelRowsPerPage = lang === "zh" ? "每頁顯示" : "Rows per page";

  return (
    <DG
      {...props}
      sx={{
        backgroundColor: "white",
        ".MuiDataGrid-columnSeparator": {
          display: "none",
        },
        ".MuiDataGrid-columnHeaders": {
          backgroundColor: "#EAF1FA",
        },
        ".MuiDataGrid-columnHeader": {
          backgroundColor: "#EAF1FA",
          paddingLeft: 2,
          paddingRight: 2,
        },
        ".MuiDataGrid-cellContent": {
          paddingLeft: 0,
          paddingRight: 0,
        },
        ".MuiDataGrid-columnHeaderTitle": {
          fontWeight: "medium",
        },
        ".MuiDataGrid-row": {
          borderBottom: "2px dashed #F3F4F6",
          cursor: props.onRowClick ? "pointer" : "default",
        },
        ".MuiDataGrid-row:last-child": {
          borderBottom: "none",
        },
        ".MuiDataGrid-cell": {
          paddingLeft: 2,
          paddingRight: 2,
          borderBottom: "none",
        },
        ".MuiDataGrid-virtualScroller": {
          overflowX: "auto",
        },
        "&.MuiDataGrid-root .MuiDataGrid-columnHeader:focus-within, &.MuiDataGrid-root .MuiDataGrid-cell:focus-within":
          { outline: "none !important" },
        ".MuiTablePagination-selectLabel, .MuiTablePagination-displayedRows": {
          fontSize: "14px",
        },
        ...props.sx,
      }}
      classes={{ virtualScroller: "!overflow-x-auto" }}
      disableRowSelectionOnClick
      disableColumnSelector
      pagination
      rowHeight={rowHeight}
      className={twMerge("font-medium", props.className)}
      slots={{
        noRowsOverlay: emptyView,
        noResultsOverlay: emptyView,
        ...props.slots,
      }}
      slotProps={{
        pagination: { ActionsComponent: GridPagination },
        ...props.slotProps,
      }}
      localeText={{
        ...l.components.MuiDataGrid.defaultProps.localeText,
        MuiTablePagination: {
          ...l.components.MuiDataGrid.defaultProps.localeText
            .MuiTablePagination,
          labelRowsPerPage,
        },
        ...props.localeText,
      }}
    />
  );
};

export default React.memo(XDataGrid);
